module.exports = __webpack_public_path__ + "images/2f6a1b19c83f9365ae0f3012d41050f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/nordea.png
// module id = 1522
// module chunks = 1